import React from "react";
import { Heart } from "lucide-react";
import { useApp } from "@/state/AppContext";
import { useRequireAuth } from "@/lib/useRequireAuth";
import { useFavoriteIds, useToggleFavorite } from "@/lib/favorites";

export function FavoriteButton({ targetType, targetId, className = "" }) {
  const requireAuth = useRequireAuth();
  const { t } = useApp();
  const { data: ids } = useFavoriteIds();
  const toggle = useToggleFavorite();

  const saved = !!ids?.[targetType]?.includes(targetId);

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Same modal + return-to-page as every other mutating action (L2).
    if (!requireAuth()) return;
    toggle.mutate({ targetType, targetId });
  };

  return (
    // RF-19: the element itself is the 44px hit area (the old 32px circle relied on an `::after`
    // that a bounding-box audit cannot see); the 32px circle is now the visible inner span, and
    // the negative margin keeps the heart where it sat on the card.
    <button
      type="button"
      data-testid={`favorite-btn-${targetType}-${targetId}`}
      onClick={onClick}
      aria-pressed={saved}
      aria-label={saved ? t("favourites.remove") : t("favourites.add")}
      className={`-m-1.5 inline-flex h-11 w-11 items-center justify-center rounded-full ${className}`}
    >
      <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-background/90 text-foreground shadow-sm transition-transform hover:scale-105">
        <Heart size={16} className={saved ? "text-[hsl(var(--accent))]" : "text-muted-foreground"} fill={saved ? "currentColor" : "none"} />
      </span>
    </button>
  );
}
